import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73d9b5e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-4" }
const _hoisted_2 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_3 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_4 = { class: "d-flex gap-2" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_11 = { class: "d-flex flex-column gap-7 gap-lg-10" }
const _hoisted_12 = { class: "card" }
const _hoisted_13 = { class: "card-body p-9" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-12 mb-7" }
const _hoisted_16 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6" }
const _hoisted_17 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_18 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_19 = { class: "text-gray-900 fw-bold" }
const _hoisted_20 = { class: "fw-semibold" }
const _hoisted_21 = { class: "fs-6 text-gray-400" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "form-group mb-7" }
const _hoisted_24 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "form-group mb-7" }
const _hoisted_27 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_28 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_29 = { class: "form-group mb-7" }
const _hoisted_30 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_31 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_32 = { class: "form-group mb-7" }
const _hoisted_33 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_34 = { class: "card" }
const _hoisted_35 = { class: "card-body p-9" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-md-12" }
const _hoisted_38 = { class: "form-group mb-7" }
const _hoisted_39 = { class: "fs-6 fw-bolder mb-2 required" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "form-group mb-7" }
const _hoisted_42 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_43 = { class: "el-form-item__content" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "form-group mb-7" }
const _hoisted_46 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_47 = { class: "el-form-item__content" }
const _hoisted_48 = { class: "col-md-6" }
const _hoisted_49 = { class: "form-group mb-7" }
const _hoisted_50 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_51 = { class: "el-form-item__content" }
const _hoisted_52 = { class: "col-md-6" }
const _hoisted_53 = { class: "form-group mb-7" }
const _hoisted_54 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_55 = { class: "el-form-item__content" }
const _hoisted_56 = { class: "col-md-6" }
const _hoisted_57 = { class: "form-group mb-7" }
const _hoisted_58 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_59 = { class: "el-form-item__content" }
const _hoisted_60 = { class: "col-md-6" }
const _hoisted_61 = { class: "form-group mb-7" }
const _hoisted_62 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_63 = { class: "el-form-item__content" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "form-group mb-7" }
const _hoisted_66 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_67 = { class: "el-form-item__content" }
const _hoisted_68 = { class: "col-md-6" }
const _hoisted_69 = { class: "form-group mb-7" }
const _hoisted_70 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_71 = { class: "el-form-item__content" }
const _hoisted_72 = { class: "col-md-6" }
const _hoisted_73 = { class: "form-group mb-7" }
const _hoisted_74 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_75 = { class: "el-form-item__content" }
const _hoisted_76 = { class: "card" }
const _hoisted_77 = { class: "card-body p-9" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-md-12" }
const _hoisted_80 = { class: "form-group mb-7" }
const _hoisted_81 = { class: "fs-6 fw-bolder mb-2 required" }
const _hoisted_82 = { class: "col-md-6" }
const _hoisted_83 = { class: "form-group mb-7" }
const _hoisted_84 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_85 = { class: "el-form-item__content" }
const _hoisted_86 = { class: "col-md-6" }
const _hoisted_87 = { class: "form-group mb-7" }
const _hoisted_88 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_89 = { class: "el-form-item__content" }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { class: "form-group mb-7" }
const _hoisted_92 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_93 = { class: "el-form-item__content" }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "form-group mb-7" }
const _hoisted_96 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_97 = { class: "el-form-item__content" }
const _hoisted_98 = { class: "col-md-6" }
const _hoisted_99 = { class: "form-group mb-7" }
const _hoisted_100 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_101 = { class: "el-form-item__content" }
const _hoisted_102 = { class: "col-md-6" }
const _hoisted_103 = { class: "form-group mb-7" }
const _hoisted_104 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_105 = { class: "el-form-item__content" }
const _hoisted_106 = { class: "col-md-6" }
const _hoisted_107 = { class: "form-group mb-7" }
const _hoisted_108 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_109 = { class: "el-form-item__content" }
const _hoisted_110 = { class: "col-md-6" }
const _hoisted_111 = { class: "form-group mb-7" }
const _hoisted_112 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_113 = { class: "el-form-item__content" }
const _hoisted_114 = { class: "col-md-6" }
const _hoisted_115 = { class: "form-group mb-7" }
const _hoisted_116 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_117 = { class: "el-form-item__content" }
const _hoisted_118 = { class: "col-md-12" }
const _hoisted_119 = { class: "form-group mb-7" }
const _hoisted_120 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_121 = { class: "el-upload__tip text-red" }
const _hoisted_122 = { class: "d-flex justify-content-between mt-4" }
const _hoisted_123 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_124 = { class: "d-flex gap-2" }
const _hoisted_125 = ["disabled"]
const _hoisted_126 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_128 = ["disabled"]
const _hoisted_129 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_common_channel_option = _resolveComponent("common-channel-option")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      rules: _ctx.rules
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            class: "btn bg-secondary align-self-center text-gray-600",
            replace: "",
            to: _ctx.goPath
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.return")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "btn bg-secondary align-self-center text-gray-600",
              disabled: _ctx.loading,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
            }, [
              _withDirectives(_createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.cancel")), 1)
              ], 512), [
                [_vShow, !_ctx.loading]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _hoisted_7,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
              ], 512), [
                [_vShow, _ctx.loading]
              ])
            ], 8, _hoisted_5),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: _ctx.loading,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, [
              _withDirectives(_createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.submit")), 1)
              ], 512), [
                [_vShow, !_ctx.loading]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
              ], 512), [
                [_vShow, _ctx.loading]
              ])
            ], 8, _hoisted_8)), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen017.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("h4", _hoisted_19, _toDisplayString(_ctx.getOwnerLabel(_ctx.userInfo.settlement_default_owner)), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("salesOrderOverview.operatingEntity")), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("salesOrder.orderType")), 1),
                    _createVNode(_component_el_form_item, { prop: "import_order_config_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          class: "w-100",
                          modelValue: _ctx.formData.import_order_config_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.import_order_config_id) = $event)),
                          placeholder: _ctx.t('common.plsSelect')
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.import_order_config_id, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value,
                                disabled: item.value != _ctx.props.checkValue
                              }, null, 8, ["label", "value", "disabled"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.t("salesOrder.customer")), 1),
                    _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          ref: "selectCustomer",
                          onFocus: _ctx.cancelReadonly,
                          "onHook:mounted": _ctx.cancelReadonly,
                          onVisibleChange: _ctx.cancelReadonly,
                          teleported: false,
                          modelValue: _ctx.formData.customer_id,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.customer_id) = $event)),
                          filterable: "",
                          clearable: "",
                          "remote-show-suffix": "",
                          remote: "",
                          "remote-method": _ctx.searchCustomerItems,
                          loading: _ctx.options.customerLoading,
                          style: {"width":"100%"},
                          placeholder: _ctx.t('common.plsSelect'),
                          onChange: _ctx.userChange
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.customer_id, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_ctx.type === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("order.merchant")), 1),
                        _createVNode(_component_el_form_item, { prop: "request_merchant_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "w-100",
                              ref: "selectMerchant",
                              onFocus: _ctx.cancelReadonly,
                              "onHook:mounted": _ctx.cancelReadonly,
                              onVisibleChange: _ctx.cancelReadonly,
                              teleported: false,
                              modelValue: _ctx.formData.request_merchant_id,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.request_merchant_id) = $event)),
                              filterable: "",
                              clearable: "",
                              "remote-show-suffix": "",
                              remote: "",
                              "remote-method": _ctx.searchMerchantSourceItems,
                              loading: _ctx.options.merchantLoading,
                              placeholder: _ctx.t('common.plsSelect'),
                              onChange: _ctx.getSalesChannelsData
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["onFocus", "onHook:mounted", "onVisibleChange", "modelValue", "remote-method", "loading", "placeholder", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.type === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.t("order.channel")), 1),
                        _createVNode(_component_el_form_item, { prop: "request_channel_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.formData.request_channel_id,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.request_channel_id) = $event)),
                              clearable: "",
                              loading: _ctx.options.channelLoading,
                              placeholder: _ctx.t('common.plsSelect')
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_common_channel_option, { channelOption: item }, null, 8, ["channelOption"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "loading", "placeholder"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.t("salesOrder.billingAddress")), 1),
                    _createVNode(_component_el_form_item, { prop: "billing_address_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.billing_address,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.billing_address) = $event)),
                          clearable: "",
                          loading: _ctx.options.billingAddressLoading,
                          style: {"width":"100%"},
                          placeholder: _ctx.t('common.plsSelect'),
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addressChange($event, 'billing')))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.billing_address_id, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t("salesOrder.billingFirstName")), 1),
                    _createElementVNode("div", _hoisted_43, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.firstname,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.options.billingAddressData.firstname) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t("salesOrder.billingLastName")), 1),
                    _createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.lastname,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.options.billingAddressData.lastname) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("salesOrder.billingCompany")), 1),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.company,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.options.billingAddressData.company) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("salesOrder.billingStreetAddress")), 1),
                    _createElementVNode("div", _hoisted_55, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.street,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.options.billingAddressData.street) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.t("salesOrder.billingCity")), 1),
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.city,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.options.billingAddressData.city) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.t("salesOrder.billingStateProvince")), 1),
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.region,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.options.billingAddressData.region) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.t("salesOrder.billingCountry")), 1),
                    _createElementVNode("div", _hoisted_67, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.country,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.options.billingAddressData.country) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.t("salesOrder.billingPostalCode")), 1),
                    _createElementVNode("div", _hoisted_71, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.postcode,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.options.billingAddressData.postcode) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.t("salesOrder.billingContactMobileNumber")), 1),
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.billingAddressData.telephone,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.options.billingAddressData.telephone) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _createElementVNode("div", _hoisted_76, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_77, [
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("div", _hoisted_80, [
                    _createElementVNode("label", _hoisted_81, _toDisplayString(_ctx.t("salesOrder.shippingAddress")), 1),
                    _createVNode(_component_el_form_item, { prop: "shipping_address_id" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.formData.shipping_address,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.shipping_address) = $event)),
                          clearable: "",
                          loading: _ctx.options.shippingAddressLoading,
                          style: {"width":"100%"},
                          placeholder: _ctx.t('common.plsSelect'),
                          onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.addressChange($event, 'shipping')))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.shipping_address_id, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "loading", "placeholder"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    _createElementVNode("label", _hoisted_84, _toDisplayString(_ctx.t("salesOrder.recipientFirstName")), 1),
                    _createElementVNode("div", _hoisted_85, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.firstname,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.options.shippingAddressData.firstname) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("label", _hoisted_88, _toDisplayString(_ctx.t("salesOrder.recipientLastName")), 1),
                    _createElementVNode("div", _hoisted_89, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.lastname,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.options.shippingAddressData.lastname) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_90, [
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.t("salesOrder.recipientCompany")), 1),
                    _createElementVNode("div", _hoisted_93, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.company,
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.options.shippingAddressData.company) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.t("salesOrder.recipientStreetAddress")), 1),
                    _createElementVNode("div", _hoisted_97, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.street,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.options.shippingAddressData.street) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.t("salesOrder.recipientCity")), 1),
                    _createElementVNode("div", _hoisted_101, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.city,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.options.shippingAddressData.city) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_102, [
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.t("salesOrder.recipientProvince")), 1),
                    _createElementVNode("div", _hoisted_105, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.region,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.options.shippingAddressData.region) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.t("salesOrder.recipientCountry")), 1),
                    _createElementVNode("div", _hoisted_109, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.country,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.options.shippingAddressData.country) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_110, [
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.t("salesOrder.recipientPostalCode")), 1),
                    _createElementVNode("div", _hoisted_113, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.postcode,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.options.shippingAddressData.postcode) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.t("salesOrder.recipientMobileNo")), 1),
                    _createElementVNode("div", _hoisted_117, [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.options.shippingAddressData.telephone,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.options.shippingAddressData.telephone) = $event)),
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_118, [
                  _createElementVNode("div", _hoisted_119, [
                    _createElementVNode("label", _hoisted_120, _toDisplayString(_ctx.t("salesOrder.selectFile")), 1),
                    _createVNode(_component_el_form_item, { prop: "importFileList" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_upload, {
                          "file-list": _ctx.formData.importFileList,
                          action: _ctx.uploadUrl,
                          headers: _ctx.uploadHeaders,
                          limit: 1,
                          accept: ".xls,.xlsx",
                          name: "import_file",
                          "auto-upload": false,
                          data: _ctx.uploadData,
                          "on-error": _ctx.handleUploadError,
                          "on-progress": _ctx.handleUploading,
                          "on-change": _ctx.handleUploadChange,
                          "on-exceed": _ctx.handleUploadExced,
                          "on-success": _ctx.handleUploadSuccess,
                          "on-remove": _ctx.handleUploadRemove,
                          ref: "uploadRef"
                        }, {
                          tip: _withCtx(() => [
                            _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.t("salesOrder.uploadTip")), 1)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              icon: _ctx.Upload
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t("salesOrder.clickToUpload")), 1)
                              ]),
                              _: 1
                            }, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["file-list", "action", "headers", "data", "on-error", "on-progress", "on-change", "on-exceed", "on-success", "on-remove"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_122, [
          _createVNode(_component_router_link, {
            class: "btn bg-secondary align-self-center text-gray-600",
            replace: "",
            to: _ctx.goPath
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_123, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.return")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_124, [
            _createElementVNode("button", {
              type: "button",
              class: "btn bg-secondary align-self-center text-gray-600",
              disabled: _ctx.loading,
              onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.handleDiscard && _ctx.handleDiscard(...args)))
            }, [
              _withDirectives(_createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_126, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.cancel")), 1)
              ], 512), [
                [_vShow, !_ctx.loading]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _hoisted_127,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
              ], 512), [
                [_vShow, _ctx.loading]
              ])
            ], 8, _hoisted_125),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: _ctx.loading,
              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, [
              _withDirectives(_createElementVNode("span", null, [
                _createElementVNode("span", _hoisted_129, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.submit")), 1)
              ], 512), [
                [_vShow, !_ctx.loading]
              ]),
              _withDirectives(_createElementVNode("span", null, [
                _hoisted_130,
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
              ], 512), [
                [_vShow, _ctx.loading]
              ])
            ], 8, _hoisted_128)), [
              [_directive_auth, { auth: ['update'] }]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}